import Keycloak, { KeycloakConfig } from 'keycloak-js';

// Keycloak configuration from environment variables
const keycloakConfig: KeycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID
};

// Global Keycloak instance
let keycloak = new Keycloak(keycloakConfig);

// Creates a fresh Keycloak instance to clear all state after logout
export const resetAndReinitializeKeycloak = () => {
  keycloak = new Keycloak(keycloakConfig);
};

export default keycloak;
